import Select from "react-select";

function FiltersAssignee({
  availableAssignees,
  selectedAssignee,
  setSelectedAssignee,
}) {
  return (
    <>
      <label>Filter by Assignee</label>
      <Select
        options={availableAssignees}
        value={selectedAssignee}
        onChange={setSelectedAssignee}
        className="mb-3"
        isClearable
      />
    </>
  );
}

export default FiltersAssignee;
